import React, { useState } from 'react';
import AppRoutes from "./AppRoutes";
import './App.css';

//import { Title } from './components/Title';
import { NavBar } from './components/NavBar';
import { Header } from './components/Header';
import { ThemeProvider } from './contexts/ThemeContext';
import { GlobalStyle } from './styles/GlobalStyle';

import useSingleTab from "./hooks/useSingleTab"; // importe o hook
import PedidoIAProf from "./components/PedidoIAProf"; // janela para aprovar a conexao com o I.A Prof
import RecoveryReminder from "./components/RecoveryReminder"; // lembrete: configurar a recuperação

const AuthenticatedApp = () => {
  const token = sessionStorage.getItem("token");
  const userType = localStorage.getItem("type");
  const [menuIsVisible, setMenuIsVisible] = useState(false);

  // Antes do login: não mostra barra nenhuma — a tela de login ocupa tudo
  // (a logo fica dentro da própria tela de login).
  if (!token) return null;

  // Responsável (pai/responsável): portal próprio, sem NavBar/Header do sistema.
  if (userType === "responsible") return null;

  // Depois do login: barra de navegação + header.
  return (
    <>
      <NavBar
        menuIsVisible={menuIsVisible}
        setMenuIsVisible={setMenuIsVisible}
      />
      <Header setMenuIsVisible={setMenuIsVisible} />
      <PedidoIAProf />
      <RecoveryReminder />
    </>
  );
};

export function App() {

  // Detecta se é mobile
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);

  // Executa o hook apenas se NÃO for mobile
  const isAnotherTabOpen = useSingleTab({
    keysToClear: ["token", "userData"],
    disableOnMobile: isMobile
  });

  if (isAnotherTabOpen) {
    return (
      <div style={{
        position: "fixed",
        top: 0, left: 0,
        width: "100%", height: "100%",
        backdropFilter: "blur(5px)",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}>
        <div style={{ background: "#fff", padding: "2rem", borderRadius: "10px", textAlign: "center" }}>
          <h2>Atenção!</h2>
          <p>O sistema já está aberto em outra aba. Feche a outra aba e atualize a pagina para continuar.</p>
        </div>
      </div>
    );
  }

  return (
    <ThemeProvider>
      <GlobalStyle />
      <div className="app">
        <AuthenticatedApp />
        <div className="container">
          <AppRoutes />
        </div>
      </div>
    </ThemeProvider>
  );
}

export default App;